<template>
  <div class="sdv-smart-block-list">
    <slot name="prepend" />
    <template v-for="(item, index) in template">
      <SmartblockItem
        :key="(item && item.id) ?? index"
        :item="item"
        class="smart-block-list__item"
        :context="context"
        :style="blockStyle"
        @action="onAction"
        @call-event="onSmartblockEvent"
        @analytics="onAnalytics"
      />
    </template>
  </div>
</template>
<script lang="ts">
/**
 * Renders a list of smartblock items.
 * Keep this component as simple as possible.
 * For example, do not bring preview vs details concept into this component.
 */
import { ExperienceActivationContext } from 'sd-types/app/experience/activation'
import { ActivationTemplate } from 'sd-types/models/activation'
import { defineComponent, PropType } from 'vue-demi'
import SmartblockItem from './SmartblockItem.vue'
import { defineSmartblockEventEmits, useBypassSmartblockEvents } from '../../composables/use-smartblock-events'

export default defineComponent({
  name: 'SmartblockList',
  components: {
    SmartblockItem
  },
  props: {
    context: {
      type: Object as PropType<ExperienceActivationContext>,
      default: () => ({})
    },
    template: {
      type: Array as PropType<ActivationTemplate[]>,
      required: false,
      default: () => []
    },
    blockStyle: {
      type: Object as PropType<Record<string, any>>,
      required: false,
      default: () => ({})
    }
  },
  emits: {
    ...defineSmartblockEventEmits()
  },
  setup (_props, context) {
    return {
      ...useBypassSmartblockEvents(context)
    }
  }
})
</script>
